import * as React from "react";
import { DayPicker } from "react-day-picker";

import { cn } from "@/lib/utils";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

/**
 * Calendar uses react-day-picker built-in styles (rdp-*).
 * Theme via global.css: --rdp-accent-color, --rdp-accent-background-color, --rdp-today-color
 */
function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("rdp-root p-4", className)}
      classNames={classNames}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
